import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';

interface WarehouseByTransactionsReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;


    filter: {
        targetDates: Date[];
    };

    items: any[];
    days: any[];
}

const state: WarehouseByTransactionsReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        targetDates: [new Date(), new Date()],
    },

    items: [],
    days: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.since) {
        queryParams.date_from = moment(params.since).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.until).format('YYYY-MM-DD')
    }

    if (params.warehouse_id !== null) {
        queryParams.warehouse_id = params.warehouse_id;
    }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<WarehouseByTransactionsReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm =(this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.warehouse_by_transactions')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');
    
                    resolve();
                }));
            } else {
                resolve();
            }
        })
    },

    exportData({state, getters}, params) {
        return new Promise((resolve, reject) => {
            const csvContent: any[] = [];
            const header = [
                'Продукт',
                'Клиент',
                'ИНН',
                'Адрес',
                'Начальный остаток',
                'Приход',
                'Расход',
                'Конечный остаток',
            ]
            csvContent.push(header);
            getters.rows.forEach((item: any) => {
                csvContent.push([
                    item.product_name,
                    (item.client_id ? item.client_name : item.detail_name),
                    item.inn,
                    item.address,
                    item.incoming,
                    item.quantity_in,
                    item.quantity_out,
                    item.outgoing
                ]);
                item.transactions.forEach((transaction: any) => {
                    csvContent.push([
                        transaction.product_name,
                        (transaction.client_id ? transaction.client_name : transaction.detail_name),
                        transaction.inn,
                        transaction.address,
                        transaction.incoming,
                        transaction.quantity_in,
                        transaction.quantity_out,
                        transaction.outgoing
                    ]);
                })
            })

            resolve(csvContent)
        })
    }


};

export const mutations: MutationTree<WarehouseByTransactionsReportState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.items = data.documents;
    },
};

const getters = {
    rows: (state: WarehouseByTransactionsReportState) => {
        
        return state.items.reduce((rows, item) => {
            const product: any = {
                class_name: 'product-row',
                product_name: item.name + ' ' + item.container_name,
                incoming: item.incoming_by_product,
                quantity_in: Math.abs(item.quantity_in_by_product),
                quantity_out: Math.abs(item.quantity_out_by_product),
                outgoing: item.outgoing_by_product,
                transactions: []
            };
            rows.push(product)
            item.transactions.forEach((transaction: any) => {
                let product_name = '';
                let detail_name = '';
                if (transaction.resort_id) {
                    product_name = 'пересорт'
                } else if (transaction.mes_export_id) {
                    product_name = `выгрузка из производства партия ${transaction.mes_plan_number} от ${moment(transaction.mes_shift_date).format('DD.MM.YYYY')}`
                } else {
                    product_name = (transaction.op == 'in' ? 'пополнение': 'заявка') + ' от ' + moment(transaction.deal_date).format('DD.MM.YYYY')
                }
                detail_name = transaction.product_name ? `${transaction.product_name}  ${transaction.product_container_name}` : ''
                if (transaction.from_product_name) {
                    detail_name = `с ${transaction.from_product_name}  ${transaction.from_product_container_name} на ${detail_name}`
                }
                product.transactions.push({
                    class_name: 'transaction-row',
                    product_name: product_name,
                    detail_name: detail_name,
                    resort_reasone: transaction.resort_reasone,
                    deal_id: transaction.deal_id,
                    client_id: transaction.client_id,
                    client_name: transaction.client_name,
                    op: transaction.op,
                    inn: transaction.inn,
                    address: transaction.address,
                    incoming: transaction.incoming,
                    quantity_in: Math.abs(transaction.op == 'in' ? transaction.quantity : 0),
                    quantity_out: Math.abs(transaction.op == 'out' ? transaction.quantity : 0),
                    outgoing: transaction.outgoing,
                })

            })
            return rows
        }, [])
    }
};

export const STORE_KEY = '$_warehouse_by_transactions_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
